var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"height":"100%","width":"100%","src":("" + _vm.getFilePath)}})])}
var staticRenderFns = []

export { render, staticRenderFns }